import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPromptSuggestion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPromptSuggestion"><Path d="M6.4 2H5.6L4.6 4.6L2 5.6V6.4L4.6 7.4L5.6 10H6.4L7.4 7.4L10 6.4V5.6L7.4 4.6L6.4 2Z" fill="currentColor"/><Path d="M18.3203 12.5938L10.707 20.207L10.4648 20.4502L10.124 20.4922L4.84863 21.1514L5.50781 15.876L5.5498 15.5352L5.79297 15.293L13.4062 7.67969L18.3203 12.5938Z" fill="currentColor"/><Path d="M22.9141 8L19.5938 11.3203L14.6797 6.40625L18 3.08594L22.9141 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPromptSuggestion;
